import { render, staticRenderFns } from "./GoldTriangleDialog.vue?vue&type=template&id=54851d60&scoped=true"
import script from "./GoldTriangleDialog.vue?vue&type=script&lang=js"
export * from "./GoldTriangleDialog.vue?vue&type=script&lang=js"
import style0 from "./GoldTriangleDialog.vue?vue&type=style&index=0&id=54851d60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54851d60",
  null
  
)

export default component.exports